<ng-container [ngSwitch]="fileType">
  <ng-container *ngSwitchCase="'pdf'">
    <svg
      id="Layer_1"
      enable-background="new 0 0 512 512"
      width="42"
      height="42"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_2_00000161628824174122363150000000951296371228825016_">
        <g id="PDF">
          <path
            d="m463.6 141.4v308.9c0 34.1-27.6 61.7-61.7 61.7h-244.8c-34.1 0-61.7-27.6-61.7-61.7v-388.6c-.1-34.1 27.6-61.7 61.7-61.7h165.1z"
            fill="#ededed"
          />
          <path
            d="m463.6 141.4h-115.9c-14.1 0-25.5-11.4-25.5-25.5v-115.9z"
            fill="#f15642"
          />
          <path
            d="m86.2 210.7h306.3c20.9 0 37.8 16.9 37.8 37.8v92c0 20.9-16.9 37.8-37.8 37.8h-306.3c-20.9 0-37.8-16.9-37.8-37.8v-92c0-20.9 16.9-37.8 37.8-37.8z"
            fill="#f15642"
          />
          <g fill="#fff">
            <path
              d="m201.9 276c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.7v-101.6h26.8c20 0 31.3 12.1 31.3 32.8zm-14.9 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11 .1 16.4-6 16.4-19.1z"
            />
            <path
              d="m214.4 243.2h25.2c19.7 0 31.3 11.6 31.3 31.6v38c0 20.1-11.6 31.9-31.2 31.9h-25.4v-101.5zm25.4 87.6c10.4 0 16.4-6.2 16.4-18.3v-37.4c0-11.9-5.8-18-16.4-18h-10.8v73.7z"
            />
            <path
              d="m303 257v30.3h30.6v13.3h-30.6v44.1h-14.6v-101.5h47.9v13.8z"
            />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'png'">
    <svg
      id="Layer_1"
      enable-background="new 0 0 512 512"
      width="42"
      height="42"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_2_00000003822536012837778830000015267835882215647934_">
        <g id="PNG">
          <path
            d="m463.6 141.4v308.9c0 34.1-27.6 61.7-61.7 61.7h-244.8c-34.1 0-61.7-27.6-61.7-61.7v-388.6c-.1-34.1 27.6-61.7 61.7-61.7h165.1z"
            fill="#ededed"
          />
          <path
            d="m463.6 141.4h-115.9c-14.1 0-25.5-11.4-25.5-25.5v-115.9z"
            fill="#f15642"
          />
          <path
            d="m86.2 210.7h306.3c20.9 0 37.8 16.9 37.8 37.8v92c0 20.9-16.9 37.8-37.8 37.8h-306.3c-20.9 0-37.8-16.9-37.8-37.8v-92c0-20.9 16.9-37.8 37.8-37.8z"
            fill="#f15642"
          />
          <g fill="#fff">
            <path
              d="m194 276c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.6v-101.5h26.8c19.9 0 31.2 12 31.2 32.7zm-14.9 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11 .1 16.4-6 16.4-19.1z"
            />
            <path
              d="m266.6 243.3v101.5h-14.6l-22.6-49.8c-3-7.5-7.2-18.1-9.7-24.6l-.4.3c1 10.1 1.7 25.4 1.7 35v39.1h-14.5v-101.5h14.6l23.3 51.7c3 6.8 6.8 16.2 9.3 22.3l.4-.3c-1.2-10-2-25.2-2-34.2v-39.6h14.5z"
            />
            <path
              d="m284 314.6v-41.3c0-20.6 11.3-31.6 29.7-31.6 18 0 28.9 10.9 29.6 30.9h-14.5c-.6-11.8-5.8-16.8-15.1-16.8s-14.8 5.4-14.8 17.7v41.2c0 12.3 5.8 17.7 15.2 17.7 9.7 0 15.5-5.4 15.5-17v-12.7h-16.1v-13h30.5v25.8c-.3 19.9-11.7 31-30 31s-30-11.3-30-31.9z"
            />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *jrSwitchCases="['jpeg', 'jpg']">
    <svg
      id="Layer_1"
      enable-background="new 0 0 512 512"
      width="42"
      height="42"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_2_00000017487846704571428500000011212469793942872246_">
        <g id="JPEG">
          <path
            d="m463.6 141.4v308.9c0 34.1-27.6 61.7-61.7 61.7h-244.8c-34.1 0-61.7-27.6-61.7-61.7v-388.6c-.1-34.1 27.6-61.7 61.7-61.7h165.1z"
            fill="#ededed"
          />
          <path
            d="m463.6 141.4h-115.9c-14.1 0-25.5-11.4-25.5-25.5v-115.9z"
            fill="#f15642"
          />
          <path
            d="m86.2 210.7h306.3c20.9 0 37.8 16.9 37.8 37.8v92c0 20.9-16.9 37.8-37.8 37.8h-306.3c-20.9 0-37.8-16.9-37.8-37.8v-92c0-20.9 16.9-37.8 37.8-37.8z"
            fill="#f15642"
          />
          <g fill="#fff">
            <path
              d="m117.1 339.6c10.9 0 16.8-4.4 16.8-18.7v-85.3h14.6v85.3c0 21.5-10.9 33.1-31.5 33.1v-14.4z"
            />
            <path
              d="m226.5 268.4c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.6v-101.6h26.8c19.9 0 31.2 12.1 31.2 32.8zm-15 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11.1 0 16.4-6 16.4-19.1z"
            />
            <path
              d="m290.1 323.4v13.8h-51.2v-101.6h49.7v13.8h-35.1v29.4h32.3v13.5h-32.3v31z"
            />
            <path
              d="m302.9 307v-41.3c0-20.6 11.3-31.6 29.7-31.6 18 0 28.9 10.9 29.6 30.9h-14.5c-.6-11.7-5.8-16.8-15.1-16.8s-14.8 5.4-14.8 17.7v41.1c0 12.3 5.8 17.7 15.2 17.7 9.7 0 15.5-5.4 15.5-17v-12.7h-16.1v-13.1h30.5v25.8c-.3 19.9-11.8 31-30 31s-30-11.1-30-31.7z"
            />
          </g>
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="'csv'">
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 0C9.05625 0 7.875 1.18125 7.875 2.625V39.375C7.875 40.8188 9.05625 42 10.5 42H36.75C38.1938 42 39.375 40.8188 39.375 39.375V10.5L28.875 0H10.5Z"
        fill="#E2E5E7"
      />
      <path
        d="M31.5 10.5H39.375L28.875 0V7.875C28.875 9.31875 30.0562 10.5 31.5 10.5Z"
        fill="#B0B7BD"
      />
      <path d="M39.375 18.375L31.5 10.5H39.375V18.375Z" fill="#CAD1D8" />
      <path
        d="M34.125 34.125C34.125 34.8469 33.5344 35.4375 32.8125 35.4375H3.9375C3.21562 35.4375 2.625 34.8469 2.625 34.125V21C2.625 20.2781 3.21562 19.6875 3.9375 19.6875H32.8125C33.5344 19.6875 34.125 20.2781 34.125 21V34.125Z"
        fill="#F91D2F"
      />
      <path
        d="M32.8125 35.4375H7.875V36.75H32.8125C33.5344 36.75 34.125 36.1594 34.125 35.4375V34.125C34.125 34.8469 33.5344 35.4375 32.8125 35.4375Z"
        fill="#CAD1D8"
      />
      <path
        d="M11.7954 28.4272H13.2725C13.2331 28.95 13.0881 29.4137 12.8374 29.8184C12.5868 30.2194 12.2376 30.5345 11.79 30.7637C11.3424 30.9928 10.8 31.1074 10.1626 31.1074C9.67204 31.1074 9.22982 31.0215 8.83594 30.8496C8.44564 30.6742 8.11084 30.4253 7.83154 30.103C7.55583 29.7772 7.34456 29.3869 7.19775 28.9321C7.05094 28.4738 6.97754 27.96 6.97754 27.3906V26.7944C6.97754 26.2251 7.05273 25.7113 7.20312 25.2529C7.35352 24.7946 7.56836 24.4043 7.84766 24.082C8.13053 23.7562 8.46891 23.5055 8.86279 23.3301C9.26025 23.1546 9.70426 23.0669 10.1948 23.0669C10.8322 23.0669 11.3711 23.1851 11.8115 23.4214C12.252 23.6541 12.5939 23.9746 12.8374 24.3828C13.0809 24.791 13.2277 25.2601 13.2778 25.79H11.8008C11.7721 25.4606 11.7005 25.1813 11.5859 24.9521C11.4749 24.723 11.3066 24.5493 11.0811 24.4312C10.859 24.3094 10.5636 24.2485 10.1948 24.2485C9.90837 24.2485 9.65592 24.3022 9.4375 24.4097C9.22266 24.5171 9.04362 24.6782 8.90039 24.8931C8.75716 25.1043 8.64974 25.3693 8.57812 25.688C8.50651 26.0031 8.4707 26.3683 8.4707 26.7837V27.3906C8.4707 27.7881 8.50293 28.1444 8.56738 28.4595C8.63184 28.7746 8.7321 29.0413 8.86816 29.2598C9.00423 29.4782 9.17969 29.6447 9.39453 29.7593C9.60938 29.8739 9.8654 29.9312 10.1626 29.9312C10.5243 29.9312 10.8179 29.8739 11.0435 29.7593C11.2726 29.6447 11.4463 29.4764 11.5645 29.2544C11.6862 29.0324 11.7632 28.7567 11.7954 28.4272ZM18.5093 28.9697C18.5093 28.8193 18.486 28.6851 18.4395 28.5669C18.3965 28.4451 18.3159 28.3359 18.1978 28.2393C18.0832 28.139 17.9202 28.0423 17.709 27.9492C17.5013 27.8525 17.2327 27.7523 16.9033 27.6484C16.5381 27.5339 16.1979 27.4049 15.8828 27.2617C15.5677 27.1185 15.2902 26.952 15.0503 26.7622C14.814 26.5724 14.6296 26.354 14.4971 26.1069C14.3646 25.8563 14.2983 25.5662 14.2983 25.2368C14.2983 24.9146 14.3664 24.6209 14.5024 24.356C14.6421 24.091 14.839 23.8636 15.0933 23.6738C15.3475 23.4805 15.6465 23.3319 15.9902 23.228C16.3376 23.1242 16.7207 23.0723 17.1396 23.0723C17.7197 23.0723 18.221 23.1779 18.6436 23.3892C19.0697 23.6004 19.3991 23.8869 19.6318 24.2485C19.8646 24.6102 19.981 25.0166 19.981 25.4678H18.5093C18.5093 25.2243 18.4574 25.0094 18.3535 24.8232C18.2533 24.637 18.0993 24.4902 17.8916 24.3828C17.6875 24.2754 17.4297 24.2217 17.1182 24.2217C16.8174 24.2217 16.5667 24.2664 16.3662 24.356C16.1693 24.4455 16.0207 24.5672 15.9204 24.7212C15.8237 24.8752 15.7754 25.047 15.7754 25.2368C15.7754 25.38 15.8094 25.509 15.8774 25.6235C15.9455 25.7345 16.0475 25.8402 16.1836 25.9404C16.3197 26.0371 16.488 26.1284 16.6885 26.2144C16.8926 26.2967 17.1289 26.3791 17.3975 26.4614C17.8271 26.5903 18.2031 26.7336 18.5254 26.8911C18.8512 27.0487 19.1216 27.2277 19.3364 27.4282C19.5549 27.6287 19.7178 27.8543 19.8252 28.105C19.9362 28.3556 19.9917 28.6403 19.9917 28.959C19.9917 29.2956 19.9255 29.5964 19.793 29.8613C19.6605 30.1263 19.4707 30.3519 19.2236 30.5381C18.9766 30.7243 18.6794 30.8657 18.332 30.9624C17.9883 31.0591 17.6034 31.1074 17.1772 31.1074C16.7977 31.1074 16.4217 31.0573 16.0493 30.957C15.6805 30.8532 15.3457 30.6992 15.0449 30.4951C14.7441 30.2874 14.5042 30.026 14.3252 29.7109C14.1462 29.3923 14.0566 29.0199 14.0566 28.5938H15.5391C15.5391 28.8408 15.5785 29.0521 15.6572 29.2275C15.7396 29.3994 15.8542 29.5409 16.001 29.6519C16.1514 29.7593 16.3268 29.8381 16.5273 29.8882C16.7279 29.9383 16.9445 29.9634 17.1772 29.9634C17.478 29.9634 17.7251 29.9222 17.9185 29.8398C18.1154 29.7539 18.2622 29.6357 18.3589 29.4854C18.4591 29.335 18.5093 29.1631 18.5093 28.9697ZM23.8804 29.4692L25.8301 23.1797H27.4683L24.7075 31H23.6172L23.8804 29.4692ZM22.0811 23.1797L24.02 29.4692L24.2993 31H23.1982L20.4482 23.1797H22.0811Z"
        fill="white"
      />
    </svg>
  </ng-container>
   <ng-container *jrSwitchCases="['xlsx','xls']">
   <img width="42"
      height="42" src="assets/images/xls-file.png" alt="">
  </ng-container>
  <ng-container *ngSwitchDefault>
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 0C9.05625 0 7.875 1.18125 7.875 2.625V39.375C7.875 40.8188 9.05625 42 10.5 42H36.75C38.1938 42 39.375 40.8188 39.375 39.375V10.5L28.875 0H10.5Z"
        fill="#E2E5E7"
      />
      <path
        d="M31.5 10.5H39.375L28.875 0V7.875C28.875 9.31875 30.0562 10.5 31.5 10.5Z"
        fill="#B0B7BD"
      />
      <path d="M39.375 18.375L31.5 10.5H39.375V18.375Z" fill="#CAD1D8" />
      <path
        d="M34.125 34.125C34.125 34.8469 33.5344 35.4375 32.8125 35.4375H3.9375C3.21562 35.4375 2.625 34.8469 2.625 34.125V21C2.625 20.2781 3.21562 19.6875 3.9375 19.6875H32.8125C33.5344 19.6875 34.125 20.2781 34.125 21V34.125Z"
        fill="#F91D2F"
      />
      <path
        d="M32.8125 35.4375H7.875V36.75H32.8125C33.5344 36.75 34.125 36.1594 34.125 35.4375V34.125C34.125 34.8469 33.5344 35.4375 32.8125 35.4375Z"
        fill="#CAD1D8"
      />
      <path
        d="M8.53516 23.1797V31H7.05811V23.1797H8.53516ZM11.688 26.5581V27.7236H8.14844V26.5581H11.688ZM12.1016 23.1797V24.3452H8.14844V23.1797H12.1016ZM14.6797 23.1797V31H13.2026V23.1797H14.6797ZM21.2378 29.8398V31H17.3062V29.8398H21.2378ZM17.752 23.1797V31H16.2749V23.1797H17.752ZM27.4092 29.8398V31H23.252V29.8398H27.4092ZM23.7031 23.1797V31H22.2261V23.1797H23.7031ZM26.8667 26.4077V27.541H23.252V26.4077H26.8667ZM27.3931 23.1797V24.3452H23.252V23.1797H27.3931Z"
        fill="white"
      />
    </svg>
  </ng-container>
</ng-container>
